import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
// components
import LoginModal from "../views/chat/modal/LoginModal";
import Shared from "./Shared";

// utils
import { MyContext } from "../context/MyContext";
import { useUIStore } from "../views/tutorV2/store";
import {
  backIncstance,
  // generateRandomString,
  getLoginInfo,
} from "../utils/commonFunctions";
// icons
// import Logo from "../assets/icons/icon_logo.svg";
// import Coin from "../assets/icons/icon_coin.png";
// import CoinClicked from "../assets/icons/icon_coin_clicked.png";
// import Mypage from "../assets/icons/icon_mypage.png";
// import MypageClicked from "../assets/icons/icon_mypage_clicked.png";
import Hamburger from "../assets/icons/icon_hamburger.png";
import Planet from "../assets/icons/tab_planet.png";
import Jisatam from "../assets/icons/logo_earth.png";
import Mypage from "../assets/icons/icon_mypage_common.png";
import MyActivity from "../assets/icons/icon_air_activities.png";
import Selected from "../assets/icons/icon_selected.png";
import GuideIcon from "../assets/icons/icon_guide_pc.png";
import GuideNew from "../assets/icons/icon_guide_new.png";
import GuideEvent from "../assets/icons/icon_guide_event_full.png";
import DSHeaderLogo from "../assets/icons/dongascienceIconOn.svg";
import CommonHeaderTop from "./CommonHeaderTop";
import { V2_PAGES, isPageInList } from "../constants/pages";

const LISTS = [
  {
    NAME: "동아사이언스",
    LINK: "/tutor",
    ICON: "https://img.dongascience.com/air/icon_logo.svg",
    ISLOGO: true,
    PATH: "main",
  },
  {
    NAME: "튜터",
    LINK: "/tutor",
    ICON: "https://img.dongascience.com/air/icon_logo.svg",
    ISLOGO: false,
    PATH: "tutor",
  },
  {
    NAME: "소크라테스",
    LINK: "/socrates",
    ICON: "https://img.dongascience.com/air/icon_logo.svg",
    ISLOGO: false,
    PATH: "socrates",
  },
];
const SETTINGS = [
  {
    NAME: "가입/로그인",
    LINK: "/login",
    ICON: null,
    ISLOGO: false,
    CLASS: "login",
  },
  {
    NAME: "구독상품안내",
    LINK: `${process.env.REACT_APP_DONGA_STORE}/subscription?anchor=2`,
    ICON: null,
    ISLOGO: false,
    CLASS: "coin",
    EXTERNAL: true,
  },
  {
    NAME: "구독인증",
    // LINK: '/login',
    LINK: `${process.env.REACT_APP_DONGA_SCHOOL}/auth`,
    ICON: null,
    ISLOGO: false,
    CLASS: "payment",
    EXTERNAL: true,
    TARGET: "_blank",
  },
];

const MYPAGE = [
  // {
  //     NAME: '요금제 안내',
  //     LINK: 'settings/products',
  //     ICON: null,
  //     PATH: 'products'
  // },
  {
    NAME: "이용가이드",
    LINK: "/guide/" + "main", // id 가 생기면 그 때 활용 할 것
    ICON: GuideIcon,
    PATH: "use-guide",
    EXTERNAL: false,
    ISEVENT: true,
    ISNEW: true,
  },
  {
    NAME: "마이페이지",
    LINK: process.env.REACT_APP_DONGA_MYPAGE || "https://my.dongascience.com",
    ICON: Mypage,
    PATH: "my-page",
    EXTERNAL: true,
  },
  {
    NAME: "나의 활동",
    LINK: "/my-activity",
    ICON: MyActivity,
    PATH: "my-activity",
  },
];
const FAMILY_SITE = {
  MAIN: process.env.REACT_APP_DONGA_MAIN,
  LIBRARY: process.env.REACT_APP_DONGA_LIBRARY,
  STORE: process.env.REACT_APP_DONGA_STORE,
  PLANET: process.env.REACT_APP_DONGA_PLANET,
  AI: process.env.REACT_APP_REFERER_URL,
  JISATAM: process.env.REACT_APP_JISATAM_URL,
  MYPAGE: process.env.REACT_APP_DONGA_MYPAGE,
};

const URLS = {
  LOGOUT: process.env.REACT_APP_LOGOUT_URL,
};
const HeaderMo = () => {
  const navigation = useNavigate();
  const location = useLocation();

  const {
    setAlertSetting,
    isStartInterview,
    isLogoHidden,
    isSticky,
    navRef,
    setList,
    setStoredList,
    setIsStartInterview,
    clearState,
    user,
    setUser,
    setHistory,
    headerRef,
    isMobile,
    openNav,
    setOpenNav,
    fetching,
    pageName,
    isLogin,
    setIsLogin,
    referrerUrl,
    setReferrerUrl,
    isAppMode,
  } = useContext(MyContext);

  const isRandingPage = location.pathname === "/";
  const isV2 = isRandingPage || isPageInList(location.pathname, V2_PAGES);

  // 240627 로그인 정보 가져오기
  const loginInfo = getLoginInfo();
  const [isShowUserInfo, setIsShowUserInfo] = useState(false);

  const modalRef = useRef(null);

  const logout = async () => {
    const response = await backIncstance("GET", URLS.LOGOUT);
    try {
      if (response.status === 200) {
        setUser((prev) => ({
          ...prev,
          id: null,
          tone: null,
          picture_extension: null,
          picture_data: null,
          name: null,
          paid: false,
          start_dt: null,
          end_dt: null,
          tutor_cnt: 0,
          socra_cnt: 0,
        }));
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("item");
        setHistory([]);
        setList([]);
        setStoredList([]);
        navigation("/");
      } else {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: "다시 시도해주세요.",
          btnTxt: "닫기",
        }));
      }
    } catch {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: "다시 시도해주세요.",
        btnTxt: "닫기",
      }));
    }
  };

  const handleClickLink = (target, item) => {
    if (isStartInterview) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `페이지를 나가면 면접이 중단됩니다.\n 면접을 끝까지 완료하셔야 평가 리포트를 볼 수 있습니다.`,
        btnTxt: "중단하고 나가기",
        double: true,
        onConfirm: () => {
          if (typeof prev.onConfirm === "function") {
            prev.onConfirm();
          }
          moveToPage(target, item);
          setIsStartInterview(false);
        },
      }));
    } else {
      moveToPage(target, item);
    }
  };

  const moveToPage = (target, item) => {
    if ((target === "마이페이지" || target === "나의 활동") && !loginInfo.id) {
      setIsLogin(true);

      // item(link)가 https://로 시작하는 경우 referrerUrl에 저장
      // 경로일 경우, hostname을 포함한 경로를 referrerUrl에 저장
      setReferrerUrl(
        typeof item === "string" &&
          (item.startsWith("http://") || item.startsWith("https://"))
          ? item
          : `${window.location.origin}${item}`,
      );
      return;
    }
    // todo 배포시 변경
    if (target === "가입/로그인" && loginInfo.id) {
      setIsShowUserInfo(!isShowUserInfo);
      return;
    }
    // 240627 로그인 정보 가져오기
    if (target === "정기구독인증") {
      alert("정기구독인증 페이지는 준비중입니다.");
      return;
    }
    if (target === "동아사이언스" && isMobile) {
      setOpenNav(!openNav);
    } else {
      setHistory([]);
      // 외부 URL인지 확인 (http:// 또는 https://로 시작하는지)
      if (
        typeof item === "string" &&
        (item.startsWith("http://") || item.startsWith("https://"))
      ) {
        // 외부 URL인 경우 window.location 또는 window.open 사용
        window.open(item, "_blank"); // 새 탭에서 열기
        // 또는 같은 탭에서 이동하려면: window.location.href = item;
      } else {
        // 내부 경로인 경우 React Router의 navigation 사용
        setOpenNav(false); // 레거시 사이드바 닫기
        useUIStore.getState().closeNav(); // V2 사이드바 닫기
        navigation(item, {
          state: {
            from_chat: null,
            is_writed: false,
            is_completed: false,
            his_cnt: 0,
          },
        });
      }
    }
  };

  const [isShowLinks, setIsShowLinks] = useState(false);

  const handleClickInfo = (e) => {
    const target = e.target.id;
    if (target.includes("logout")) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: "로그아웃 하시겠습니까?",
        double: true,
        btnTxt: "로그아웃",
        onConfirm: () => {
          logout();
          clearState();
        },
      }));
    } else {
      setIsShowLinks(true);
    }
  };

  const handleOutsideClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setIsShowUserInfo(false);
    }
  };
  useEffect(() => {
    if (isShowUserInfo) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isShowUserInfo]);
  const DetailInfo = (props) => {
    const { handleClickInfo } = props;

    return (
      <ul className="detail-info" onClick={handleClickInfo} ref={modalRef}>
        <li id="link-history">공유 이력 보기</li>
        <li id="logout">로그아웃</li>
      </ul>
    );
  };

  // 유효한 로그인 상태인지 확인하는 함수
  const isValidLogin = () => {
    // return loginInfo.id && loginInfo.accessToken && user?.id;
    return user && user.id ? true : false;
  };

  const moveToMyPage = () => {
    const url = isValidLogin()
      ? FAMILY_SITE.MYPAGE
      : `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}`;
    const openNewTab = isAppMode && url === FAMILY_SITE.MYPAGE;

    openNewTab ? window.open(url) : window.location.assign(url);
  };

  return (
    <div className="hd-wrp" ref={headerRef}>
      {isAppMode ? null : <CommonHeaderTop />}
      {/* hd-tit-wrp-mo 비활성화 - 더 이상 사용하지 않음 */}
      {false && (
        <div className="hd-tit-wrp-mo">
          <div className={`bottom ${!isMobile ? "flx-box sep-elm" : ""}`}>
            {/* {isMobile && (
            <div className={`flx-box mo-logo ${isLogoHidden ? "hidden" : ""}`}>
              <img src="https://img.dongascience.com/air/icon_logo.svg" alt="" />
            </div>
          )} */}
            <ul className={`hd-wrp__nv flx-box ${isSticky ? "sticky" : ""}`}>
              {LISTS.map((listItem, listIdx) => {
                return (
                  <li
                    key={listItem.PATH}
                    className={`hd-wrp__nv__it ${isMobile ? "" : "crs-btn"}`}
                    id={listItem.NAME}
                    onClick={() =>
                      !fetching && handleClickLink(listItem.NAME, listItem.LINK)
                    }
                  >
                    {listItem.ISLOGO ? (
                      <img
                        className="hd-lg"
                        src={!isMobile ? listItem.ICON : Hamburger}
                        alt="LOGO"
                      />
                    ) : (
                      <span
                        className="hd-lk"
                        style={
                          pageName === listItem.PATH
                            ? { color: "#4524C9", fontWeight: "700" }
                            : { color: "#6C6C6C" }
                        }
                      >
                        {listItem.NAME}
                      </span>
                    )}
                  </li>
                );
              })}
              {isMobile && (
                <li
                  className={`hd-wrp__nv__it crs-btn`}
                  style={{ position: "absolute", right: 0, marginTop: 6 }}
                  onClick={moveToMyPage}
                >
                  <span className="hd-lk">
                    <img src={Mypage} alt="link-to-mypage" height={24} />
                  </span>
                </li>
              )}
            </ul>
            {!isMobile && (
              <div className="flx-box hd-wrp__nv_right gap-12">
                {MYPAGE.map((item, idx) => {
                  return (
                    <div key={item.NAME} className="hd-wrp__st flx-box">
                      <div
                        className="hd-wrp__st__it crs-btn flx-col"
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() =>
                          !fetching && handleClickLink(item.NAME, item.LINK)
                        }
                      >
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{ width: 32 }}
                            src={item.ICON}
                            alt="link-to-mypage"
                          />
                          {item.ISEVENT && (
                            <span className="event-badge">
                              <img
                                src={GuideEvent}
                                alt="EVENT"
                                style={{ width: "100%", height: "100%" }}
                              />
                            </span>
                          )}
                          {item.ISNEW && (
                            <span className="new-badge">
                              <img
                                src={GuideNew}
                                alt="NEW"
                                style={{ width: "100%", height: "100%" }}
                              />
                            </span>
                          )}
                        </div>
                        <span
                          style={
                            pageName === item.PATH
                              ? {
                                  color: "#4524C9",
                                  fontWeight: "700",
                                }
                              : { color: "#6C6C6C" }
                          }
                          className="hd-lk"
                        >
                          {item.NAME}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
      {/* {isLogin && <LoginModal />} */}
      {isShowLinks && <Shared onClose={() => setIsShowLinks(false)} />}
    </div>
  );
};
export default HeaderMo;
